module.exports = "https://coursera_assets.s3.amazonaws.com/images/e80434394ca08796a7fb9303a331720a.png";